export default __webpack_public_path__ + "static/media/card-partner.8cf60b20.png";